import request from '@/_util/require';

let version = 'v1';
const basePath = `/${version}/waper/erp/pc/ai/tokenconfig`;

/**
 * 分页查询AI员工Token配额列表
 * @param {Object} data - { page: { pageNo, pageSize, sortFields } }
 */
export async function getTokenConfigPage(data) {
  return request(`${basePath}/costrankpage`, {
    method: 'POST',
    data,
  });
}

/**
 * 设置员工Token总配额
 * @param {Object} data - AI员工Token配额配置信息
 */
export async function initQuota(data) {
  return request(`${basePath}/initquota`, {
    method: 'POST',
    data,
  });
}
